import { Component, Input } from '@angular/core';
import { EmergencyNumber } from '../../models/emergency-number.model';
import { FormGroup, Validators } from '@angular/forms';
import { DataFormModel } from '../../models/data-form-model.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmergencyNumberService } from '../../services/emergency-number.service';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'app-emergency-number-modal',
  templateUrl: './emergency-number-modal.component.html',
  styleUrl: './emergency-number-modal.component.scss'
})
export class EmergencyNumberModalComponent {

  @Input() neighborhoodId: string = '';
  @Input() emergencyNumber?: EmergencyNumber;

  public dataForm: DataFormModel = {
    phoneNumber: {
      value: '',
      type: 'text',
      label: 'Número de emergencia',
      requiredMessage: 'Por favor, ingrese el número de emergencia',
      required: true,
      validators: [Validators.required]
    },
    description: {
      value: '',
      type: 'text',
      label: 'Alias del número',
      requiredMessage: 'Por favor, ingrese un alias para el número',
      required: true,
      validators: [Validators.required]
    },
    status: {
      value: false,
      type: 'switch',
      label: 'Publicado',
      required: false,
    },
  };

  public submitted: boolean = false;
  public loading: boolean = false;

  public formEmergencyNumber!: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    public emergencyNumberService: EmergencyNumberService,
    public utilService: UtilService,
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  get f() {
    return this.formEmergencyNumber.controls;
  }

  /*
   ██████╗██████╗ ███████╗ █████╗ ████████╗███████╗
  ██╔════╝██╔══██╗██╔════╝██╔══██╗╚══██╔══╝██╔════╝
  ██║     ██████╔╝█████╗  ███████║   ██║   █████╗
  ██║     ██╔══██╗██╔══╝  ██╔══██║   ██║   ██╔══╝
  ╚██████╗██║  ██║███████╗██║  ██║   ██║   ███████╗
   ╚═════╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝   ╚═╝   ╚══════╝

  */
   async create() {

    const flag = await this.emergencyNumberService.create(
      this.neighborhoodId!,
      this.formEmergencyNumber.value,
    );

    if(flag) {
      for(let key of Object.keys(this.dataForm)) {
        this.dataForm[key].value = '';
      }

      this.activeModal.close();
    }

  }

  /*
  ██╗      ██████╗  █████╗ ██████╗ ██████╗  █████╗ ████████╗ █████╗
  ██║     ██╔═══██╗██╔══██╗██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝██╔══██╗
  ██║     ██║   ██║███████║██║  ██║██║  ██║███████║   ██║   ███████║
  ██║     ██║   ██║██╔══██║██║  ██║██║  ██║██╔══██║   ██║   ██╔══██║
  ███████╗╚██████╔╝██║  ██║██████╔╝██████╔╝██║  ██║   ██║   ██║  ██║
  ╚══════╝ ╚═════╝ ╚═╝  ╚═╝╚═════╝ ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚═╝  ╚═╝

  */
  async loadData() {
    this.loading = true;

    if(this.emergencyNumber) {

      this.dataForm = {
        ...this.dataForm,
      }

      for(let key of Object.keys(this.dataForm)) {

        if (key in this.emergencyNumber!) {
          const standardKey = key as keyof typeof this.emergencyNumber;
      
          // Ahora puedes acceder a `this.machine[machineKey]` sin errores de tipo.
          this.dataForm[key].value = this.emergencyNumber[standardKey]!;
        }
      } 
    }
    
    this.formEmergencyNumber = this.utilService.buildForm(this.dataForm);

    this.loading = false;
  }

  /*
   ██████╗ ███╗   ██╗███████╗██╗   ██╗██████╗ ███╗   ███╗██╗████████╗
  ██╔═══██╗████╗  ██║██╔════╝██║   ██║██╔══██╗████╗ ████║██║╚══██╔══╝
  ██║   ██║██╔██╗ ██║███████╗██║   ██║██████╔╝██╔████╔██║██║   ██║
  ██║   ██║██║╚██╗██║╚════██║██║   ██║██╔══██╗██║╚██╔╝██║██║   ██║
  ╚██████╔╝██║ ╚████║███████║╚██████╔╝██████╔╝██║ ╚═╝ ██║██║   ██║
   ╚═════╝ ╚═╝  ╚═══╝╚══════╝ ╚═════╝ ╚═════╝ ╚═╝     ╚═╝╚═╝   ╚═╝

  */
  async onSubmit() {

    console.log(this.formEmergencyNumber.value);
    
    this.submitted = true;

    if(this.formEmergencyNumber.invalid) {
      return;
    }

    if(this.emergencyNumber) {

      await this.update();
    } else {
      await this.create();
    }
  }

  /*
  ██╗   ██╗██████╗ ██████╗  █████╗ ████████╗███████╗
  ██║   ██║██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝██╔════╝
  ██║   ██║██████╔╝██║  ██║███████║   ██║   █████╗
  ██║   ██║██╔═══╝ ██║  ██║██╔══██║   ██║   ██╔══╝
  ╚██████╔╝██║     ██████╔╝██║  ██║   ██║   ███████╗
   ╚═════╝ ╚═╝     ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚══════╝

  */
  async update() {

    this.formEmergencyNumber.value.emergencyNumberId = this.emergencyNumber!.emergencyNumberId;
    this.formEmergencyNumber.value.neighborhoodId = this.emergencyNumber!.neighborhoodId;

    const flag = await this.emergencyNumberService.update(
      this.formEmergencyNumber.value
    );

    if(flag) {

      for(let key of Object.keys(this.dataForm)) {
        this.dataForm[key].value = '';
      }

      this.activeModal.close();
    }
  }

}
